(() => {
 function mount(root) {
  if(root.dataset.mounted) return; root.dataset.mounted='true';

  const weekButtons=[...root.querySelectorAll('[data-week-button]')];
  const weekPanels=[...root.querySelectorAll('[data-week-panel]')];
  function showWeek(number) {
   if(!weekPanels.some(panel=>panel.dataset.weekPanel===number))return;
   weekPanels.forEach(panel=>{panel.hidden=panel.dataset.weekPanel!==number;});
   weekButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.weekButton===number)));
  }
  weekButtons.forEach(button=>{button.disabled=!weekPanels.some(panel=>panel.dataset.weekPanel===button.dataset.weekButton);button.addEventListener('click',()=>showWeek(button.dataset.weekButton));});
  showWeek('1');
  root.addEventListener('shopify:block:select',event=>{
   const panel=event.target.closest('[data-week-panel]');
   if(panel&&root.contains(panel))showWeek(panel.dataset.weekPanel);
  });
  const dialog=root.querySelector('dialog'), stage=root.querySelector('[data-stage]'), answer=root.querySelector('[data-answer]');
  root.querySelector('[data-close]').onclick=()=>dialog.close();
  dialog.addEventListener('close',()=>{stage.replaceChildren();answer.reset();answer.querySelector('button').disabled=false;answer.querySelector('textarea').readOnly=false;root.querySelector('[data-answer-status]').textContent='';});
  root.querySelectorAll('[data-video]').forEach(button=>button.onclick=()=>{
   let url;try {url=new URL(button.dataset.video);if(url.protocol!=='https:'||!['iframe.mediadelivery.net','video.bunnycdn.com'].includes(url.hostname)||!/^\/(embed|play)\/\d+\/[a-zA-Z0-9-]+\/?$/.test(url.pathname))throw Error();}catch{alert('Please add a valid Bunny embed or play link in the theme editor.');return;}
   url.pathname=url.pathname.replace('/play/','/embed/');url.searchParams.set('autoplay','false');
   const iframe=document.createElement('iframe');iframe.src=url.href;iframe.title=button.dataset.title;iframe.allow='accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen';iframe.allowFullscreen=true;
   root.querySelector('[data-video-title]').textContent=button.dataset.title;stage.replaceChildren(iframe);answer.hidden=!button.hasAttribute('data-prompt');answer.querySelector('[data-prompt]').textContent=button.dataset.prompt||'';dialog.showModal();
  });
  answer.onsubmit=e=>{e.preventDefault();const input=answer.querySelector('textarea');if(!input.value.trim()){input.setCustomValidity('Please enter an answer.');input.reportValidity();return;}input.readOnly=true;answer.querySelector('button').disabled=true;root.querySelector('[data-answer-status]').textContent='✓ Completed!';};
  answer.querySelector('textarea').oninput=e=>e.target.setCustomValidity('');
  const stepsDialog=root.querySelector('[data-steps-dialog]');
  const stepsStage=root.querySelector('[data-steps-stage]');
  root.querySelector('[data-close-steps]').onclick=()=>stepsDialog.close();
  root.querySelectorAll('[data-submit-steps]').forEach(button=>button.onclick=()=>{
   if(!stepsStage.firstElementChild){
    const iframe=document.createElement('iframe');
    iframe.src=stepsDialog.querySelector('a').href;
    iframe.title='Turkey Trot step tracker';
    iframe.allow='camera; microphone; autoplay; encrypted-media; fullscreen';
    stepsStage.append(iframe);
   }
   stepsDialog.showModal();
  });
  const total=root.querySelector('[data-community-total]');
  const status=root.querySelector('[data-counter-status]');
  const refresh=root.querySelector('[data-refresh-total]');
  const progress=root.querySelector('[data-progress]');
  function updateProgress(count){
   if(!progress)return;
   const goal=5000000;
   const percent=Math.min(count/goal*100,100);
   progress.hidden=false;
   progress.style.setProperty('--progress',percent+'%');
   const bar=progress.querySelector('[data-progress-bar]');
   bar.setAttribute('aria-valuenow',String(Math.min(count,goal)));
   bar.setAttribute('aria-valuetext',count.toLocaleString('en-US')+' of 5,000,000 steps'+(count>=goal?' — goal reached!':''));
   const label=count>=goal?'100% — goal reached!':count>0&&percent<0.1?'Less than 0.1%':(Math.floor(percent*10)/10).toLocaleString('en-US',{maximumFractionDigits:1})+'%';
   progress.querySelector('[data-progress-percent]').textContent=label;
  }
  let lastTotal=null;
  async function refreshTotal(){
   if(!total||refresh.disabled)return;
   refresh.disabled=true;status.textContent='Refreshing community total…';
   const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
   try{
    const url=new URL(root.dataset.counterUrl);
    if(url.protocol!=='https:'||url.hostname!=='docs.google.com'||!url.pathname.startsWith('/spreadsheets/d/e/')||!url.pathname.endsWith('/pub'))throw Error('Invalid feed');
    url.searchParams.set('output','csv');
    const response=await fetch(url.href,{signal:controller.signal,credentials:'omit',cache:'no-store'});
    if(!response.ok)throw Error('Feed unavailable');
    const csv=(await response.text()).replace(/^\uFEFF/,'').trim();
    const lines=csv.split(/\r?\n/).filter(line=>line.trim());
    // Accept the supplied one-cell feed, or an optional header followed by a value.
    if(lines.length<1||lines.length>2)throw Error('Unexpected feed');
    if(lines.length===2&&!/^"?Community steps"?$/i.test(lines[0].trim()))throw Error('Unexpected header');
    const value=lines[lines.length-1].trim().replace(/^"(.*)"$/,'$1');
    if(!/^(?:\d+|\d{1,3}(?:,\d{3})+)$/.test(value))throw Error('Invalid total');
    const count=Number(value.replace(/,/g,''));
    if(!Number.isSafeInteger(count)||count<0)throw Error('Invalid total');
    lastTotal=count;total.textContent=count.toLocaleString('en-US');updateProgress(count);
    status.textContent='Latest published total';
   }catch{
    status.textContent=lastTotal===null?'The total is temporarily unavailable. You can still log your walk using Submit Steps on any day.':'Could not refresh. Showing the last loaded total; you can still log your walk using Submit Steps on any day.';
   }finally{clearTimeout(timeout);refresh.disabled=false;}
  }
  if(refresh){refresh.addEventListener('click',refreshTotal);refreshTotal();}


 }
 const init=()=>document.querySelectorAll('[data-turkey-trot]').forEach(mount);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();
